<template>

    <div>

        <div class="row row-cols-1 row-cols-lg-2 mb-4">

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Allgemein') }}</legend>
                            <checkbox-input label="enabled" v-model="form.enabled" :error="form.errors.enabled" />
                            <text-input label="Name" v-model="form.name" :error="form.errors.name" />
                            <textarea-input label="description" v-model="form.description" :error="form.errors.description" />
                            <text-input type="number" label="delivery_time" v-model="form.delivery_time" :error="form.errors.delivery_time" />
                        </fieldset>
                    </div>
                </div>
            </div>
            
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Misc') }}</legend>
                            <text-input type="number" label="sort_order" v-model="form.sort_order" :error="form.errors.sort_order" />
                            <select-input label="tax_calc_mode" v-model="form.tax_calc_mode">
                                <option :value="k" v-for="(v, k) in taxCalcModeOptions">{{ v }}</option>
                            </select-input>
                            <percent-input label="tax_rate" v-model="form.tax_rate" :error="form.errors.tax_rate" v-if="form.tax_calc_mode === 'value'" />
                            <checkbox-input label="free_delivery_for_all_cart_items"
                                            v-model="form.free_delivery_for_all_cart_items"
                                            :error="form.errors.free_delivery_for_all_cart_items"
                                            :help="__('Wenn der Warenkorb einen versandkostenfreien Artikel enthält, wird der gesamte Warenkorb versandkostenfrei.')" />
                        </fieldset>
                    </div>
                </div>
            </div>

        </div>

        <div class="row row-cols-1 g-4">

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Preise') }}</legend>
                            <div class="row" v-for="(option, optionIndex) in form.options">
                                <div class="col">
                                    <price-input label="lower_bound" v-model="option.lower_bound" :error="form.errors[`options.${optionIndex}.lower_bound`]" />        
                                </div>
                                <div class="col">
                                    <price-input label="upper_bound" placeholder="∞" v-model="option.upper_bound" :error="form.errors[`options.${optionIndex}.upper_bound`]" />        
                                </div>
                                <div class="col">
                                    <price-input label="amount" v-model="option.amount" :error="form.errors[`options.${optionIndex}.amount`]" />        
                                </div>
                                <div class="col d-flex gap-2 align-items-center">
                                    <button type="button" class="btn btn-outline-secondary" @click="cloneOption(optionIndex)">
                                        {{ __('Duplizieren') }}
                                    </button>
                                    <button type="button" class="btn btn-outline-danger" v-if="optionIndex > 0" @click="removeOption(optionIndex)">
                                        {{ __('Löschen') }}
                                    </button>
                                </div>
                            </div>
                            <button type="button" class="btn btn-outline-primary" @click="addOption()">
                                <i class="bi bi-plus"></i>
                                {{ __('Option hinzufügen') }}
                            </button>  
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center w-100">
                <submit-button :form="form" />
                <button type="button" class="btn link-danger" @click="destroy" v-if="deliveryOption">
                    {{ __('Löschen') }}
                </button>
            </div>

        </div>

    </div>

</div>

</div>
</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import PriceInput from '@/shared/Inputs/PriceInput';
    import PercentInput from '@/shared/Inputs/PercentInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
            'form',
            'deliveryOption',
            'taxCalcModeOptions',
        ],
        data() {
            return {
            }
        },
        components: {
            TextInput,
            PriceInput,
            PercentInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            SubmitButton,
        },
        watch: {
        },
        methods: {
            addOption() {

                if (this.form.options.length >= 100) {
                    alert('Sie können maximal 100 Optionen angeben.');
                    return false;
                }

                const option = {
                };
                this.form.options.push(option);
            },
            cloneOption(index) {
                if (this.form.options.length >= 100) {
                    alert('Sie können maximal 100 Optionen angeben.');
                    return false;
                }

                let cloned = JSON.parse(JSON.stringify(this.form.options[index]));
                this.form.options.push(cloned);
            },
            removeOption(index) {
                Vue.delete(this.form.options, index);
            },
            destroy() {
                if (confirm(this.__('Sind Sie sicher?'))) {
                    this.$inertia.delete(this.route('admin.delivery-options.destroy', this.deliveryOption));
                }
            },
        },
    }
</script>
